import sanityClient from "@sanity/client";

export default sanityClient({
  // Find your project ID and dataset in `sanity.json` in your studio project
  //projectId: "zp7mbokg",
  projectId: "vkwa9e3p",
  dataset: "production",
  apiVersion: '2021-10-21',
  token: 'skGDlTpO6JpLYWIEHPoG2fj7ZEmKByA6RPnY5e726rGcY6XaVukZE8VsOPzsyVYW2Q0hT1wUWRjhNt7dvnkSHHLHaodC22uxGrFVfYWZQMzi2rN6YGEXfGX3sTIyhhfgskGDvc8fESgXvjM7C02w62z0TeGHNHXm8TmEsYKmqGjHmeWVV3Rk', // or leave blank for unauthenticated usage
  useCdn: true
  // useCdn == true gives fast, cheap responses using a globally distributed cache.
  // Set this to false if your application require the freshest possible
  // data always (potentially slightly slower and a bit more expensive).
});